"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixLevels = exports.prefixes = void 0;
exports.error = error;
exports.warn = warn;
exports.info = info;
exports.event = event;
const picocolors_1 = require("../lib/picocolors");
exports.prefixes = {
    error: (0, picocolors_1.red)((0, picocolors_1.bold)('⨯')),
    warn: (0, picocolors_1.yellow)((0, picocolors_1.bold)('⚠')),
    info: (0, picocolors_1.white)((0, picocolors_1.bold)(' ')),
    event: (0, picocolors_1.green)((0, picocolors_1.bold)('✓')),
};
exports.prefixLevels = {
    silent: Infinity,
    error: 40,
    warn: 30,
    info: 20,
    event: 10,
};
const suffix = '(next-runtime-env)';
const LOGGING_METHOD = {
    log: 'log',
    warn: 'warn',
    error: 'error',
};
function prefixedLog(prefixType, message, options) {
    const { logLevel = 'event' } = options || {};
    if (exports.prefixLevels[prefixType] < exports.prefixLevels[logLevel]) {
        return;
    }
    const consoleMethod = prefixType in LOGGING_METHOD
        ? LOGGING_METHOD[prefixType]
        : 'log';
    const prefix = exports.prefixes[prefixType];
    // eslint-disable-next-line no-console
    console[consoleMethod](` ${prefix}`, message, suffix);
}
function error(message, options) {
    prefixedLog('error', message, options);
}
function warn(message, options) {
    prefixedLog('warn', message, options);
}
function info(message, options) {
    prefixedLog('info', message, options);
}
function event(message, options) {
    prefixedLog('event', message, options);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hlbHBlcnMvbG9nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQTBEQSxzQkFFQztBQUVELG9CQUVDO0FBRUQsb0JBRUM7QUFFRCxzQkFFQztBQXhFRCxrREFBb0U7QUFhdkQsUUFBQSxRQUFRLEdBQUc7SUFDdEIsS0FBSyxFQUFFLElBQUEsZ0JBQUcsRUFBQyxJQUFBLGlCQUFJLEVBQUMsR0FBRyxDQUFDLENBQUM7SUFDckIsSUFBSSxFQUFFLElBQUEsbUJBQU0sRUFBQyxJQUFBLGlCQUFJLEVBQUMsR0FBRyxDQUFDLENBQUM7SUFDdkIsSUFBSSxFQUFFLElBQUEsa0JBQUssRUFBQyxJQUFBLGlCQUFJLEVBQUMsR0FBRyxDQUFDLENBQUM7SUFDdEIsS0FBSyxFQUFFLElBQUEsa0JBQUssRUFBQyxJQUFBLGlCQUFJLEVBQUMsR0FBRyxDQUFDLENBQUM7Q0FDMEIsQ0FBQztBQUV2QyxRQUFBLFlBQVksR0FBRztJQUMxQixNQUFNLEVBQUUsUUFBUTtJQUNoQixLQUFLLEVBQUUsRUFBRTtJQUNULElBQUksRUFBRSxFQUFFO0lBQ1IsSUFBSSxFQUFFLEVBQUU7SUFDUixLQUFLLEVBQUUsRUFBRTtDQUMwRCxDQUFDO0FBRXRFLE1BQU0sTUFBTSxHQUFHLG9CQUFvQixDQUFDO0FBRXBDLE1BQU0sY0FBYyxHQUFHO0lBQ3JCLEdBQUcsRUFBRSxLQUFLO0lBQ1YsSUFBSSxFQUFFLE1BQU07SUFDWixLQUFLLEVBQUUsT0FBTztDQUNOLENBQUM7QUFFWCxTQUFTLFdBQVcsQ0FDbEIsVUFBaUMsRUFDakMsT0FBZSxFQUNmLE9BQW9CO0lBRXBCLE1BQU0sRUFBRSxRQUFRLEdBQUcsT0FBTyxFQUFFLEdBQUcsT0FBTyxJQUFJLEVBQUUsQ0FBQztJQUU3QyxJQUFJLG9CQUFZLENBQUMsVUFBVSxDQUFDLEdBQUcsb0JBQVksQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDO1FBQ3RELE9BQU87SUFDVCxDQUFDO0lBRUQsTUFBTSxhQUFhLEdBQ2pCLFVBQVUsSUFBSSxjQUFjO1FBQzFCLENBQUMsQ0FBQyxjQUFjLENBQUMsVUFBeUMsQ0FBQztRQUMzRCxDQUFDLENBQUMsS0FBSyxDQUFDO0lBRVosTUFBTSxNQUFNLEdBQUcsZ0JBQVEsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUVwQyxzQ0FBc0M7SUFDdEMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxDQUFDLElBQUksTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0FBQ3hELENBQUM7QUFFRCxTQUFnQixLQUFLLENBQUMsT0FBZSxFQUFFLE9BQW9CO0lBQ3pELFdBQVcsQ0FBQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3pDLENBQUM7QUFFRCxTQUFnQixJQUFJLENBQUMsT0FBZSxFQUFFLE9BQW9CO0lBQ3hELFdBQVcsQ0FBQyxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3hDLENBQUM7QUFFRCxTQUFnQixJQUFJLENBQUMsT0FBZSxFQUFFLE9BQW9CO0lBQ3hELFdBQVcsQ0FBQyxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3hDLENBQUM7QUFFRCxTQUFnQixLQUFLLENBQUMsT0FBZSxFQUFFLE9BQW9CO0lBQ3pELFdBQVcsQ0FBQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3pDLENBQUMifQ==